/**
 * Parses an enum into a plain object.
 *
 * This function takes an enum and returns a plain object where each key of the
 * enum is mapped to its own value.
 *
 * @template T - The type of the enumeration object.
 * @param enumObject - The enumeration object to parse.
 * @returns A plain object where each key of the enumeration is mapped to its
 *   own value.
 */
export function enumToPlainObject<T extends Record<string | number, unknown>>(
  enumObject: T,
): { [K in keyof T]: K } {
  const mappedObj = {} as { [K in keyof T]: keyof T };
  for (const key in enumObject) {
    if (isNaN(Number(key))) {
      mappedObj[key] = key;
    }
  }
  return mappedObj as { [K in keyof T]: K };
}
